import { createBulkUpdateOperation } from './create'
import { read } from './read'

export const bulkOperation = {
  read,
  create: createBulkUpdateOperation,
}
